import { render } from "./invoicecancelled.vue?vue&type=template&id=780402f9"
import script from "./invoicecancelled.vue?vue&type=script&lang=js"
export * from "./invoicecancelled.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__